import {columnsDefinitions, resolveFields, citySelectList, agentSelectList, menyraKontaktimitList, datatableUrl} from "../helpers/datatables_helpers";
import datepickerFactory from 'jquery-datepicker';
import datepickerJAFactory from 'jquery-datepicker/i18n/jquery.ui.datepicker-ja';
const ContactDatatable = () => {

    //const model = $('#context').attr('data-model');
    //console.log('DT MODEL IS: ' + model);
    const tableFields = resolveFields(model);
    console.log("TABLE FIELDS ARE: " + tableFields)
    // begin first table
    let model = 'contact';
    console.log("datatableurl is: " + datatableUrl())
    let table = $('#kt_datatable').DataTable({
        responsive: true,
        autoWidth: false,
        // Pagination settings
        dom: `<'row'<'col-sm-12'tr>>
			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,
        // read more: https://datatables.net/examples/basic_init/dom.html
        lengthMenu: [5, 10, 25, 50],
        pageLength: 10,
        order: [[2,'desc']],
        language: {
            'lengthMenu': 'Display _MENU_',
        },
        searchDelay: 500,
        processing: true,
        serverSide: true,
        ajax: {
            url: datatableUrl(),
            type: 'GET',
            data: {
                // parameters for custom backend script demo
                model: model,
                columnsDef: tableFields,
            },
        },
        columns: columnsDefinitions(model),
        initComplete: function() {
            var thisTable = this;
            var rowFilter = $('<tr class="filter"></tr>').appendTo($(table.table().header()));

            this.api().columns().every(function() {
                var column = this;
                var input;

                switch (column.title()) {
                    case 'Emri':
                    case 'Telefoni':
                        input = $(`<input type="text" class="form-control form-control-sm form-filter datatable-input" data-col-index="` + column.index() + `"/>`);
                        break;
                    case 'Menyra kontaktimit':
                        input = menyraKontaktimitList(column)
                        break;
                    case 'Dite pa kontakt':
                        input = $(`<input type="text" class="form-control form-control-sm form-filter datatable-input" data-col-index="` + column.index() + `"/>`);
                        break;
                    case 'Qyteti':
                        input = citySelectList(column);
                        break;
                    case 'Agjenti':
                        input = agentSelectList(column);
                        break;
                    case 'Data kontaktimit':
                        input = $(`
    							<div class="input-group date">
    								<input type="text" class="form-control form-control-sm datatable-input" readonly placeholder="Prej" id="kt_datepicker_1"
    								 data-col-index="` + column.index() + `"/>
    								<div class="input-group-append">
    									<span class="input-group-text"><i class="la la-calendar-o glyphicon-th"></i></span>
    								</div>
    							</div>
    							<div class="input-group date d-flex align-content-center">
    								<input type="text" class="form-control form-control-sm datatable-input" readonly placeholder="Deri" id="kt_datepicker_2"
    								 data-col-index="` + column.index() + `"/>
    								<div class="input-group-append">
    									<span class="input-group-text"><i class="la la-calendar-o glyphicon-th"></i></span>
    								</div>
    							</div>`);
                        break;
                    case 'Actions':
                        var search = $(`
                                <button class="btn btn-primary kt-btn btn-sm kt-btn--icon d-block col-md-12 col-lg-12">
							        <span>
							            <i class="fa fa-search"></i>
							            <span>Filtro</span>
							        </span>
							    </button>`);

                        var reset = $(`
                                <button class="btn btn-secondary kt-btn btn-sm kt-btn--icon col-md-12 col-lg-12" >
							        <span>
							           <i class="fa fa-close"></i>
							           <span>Reset</span>
							        </span>
							    </button>`);

                        $('<th>').append(search).append(reset).appendTo(rowFilter);

                        $(search).on('click', function(e) {
                            e.preventDefault();
                            var params = {};
                            $(rowFilter).find('.datatable-input').each(function() {
                                var i = $(this).data('col-index');
                                if (params[i]) {
                                    params[i] += '|' + $(this).val();
                                } else {
                                    params[i] = $(this).val();
                                }
                            });
                            $.each(params, function(i, val) {
                                // apply search params to datatable
                                table.column(i).search(val ? val : '', false, false);
                            });
                            table.table().draw();
                        });

                        $(reset).on('click', function(e) {
                            e.preventDefault();
                            $(rowFilter).find('.datatable-input').each(function(i) {
                                $(this).val('');
                                table.column($(this).data('col-index')).search('', false, false);
                            });
                            table.table().draw();
                        });
                        break;
                }

                if (column.title() !== 'Actions') {
                    $(input).appendTo($('<th>').appendTo(rowFilter));
                }
            });

            // hide search column for responsive table
            var hideSearchColumnResponsive = function() {
                thisTable.api().columns().every(function() {
                    var column = this
                    if (column.responsiveHidden()) {
                        $(rowFilter).find('th').eq(column.index()).show();
                    } else {
                        $(rowFilter).find('th').eq(column.index()).hide();
                    }
                })
            };

            // init on datatable load
            hideSearchColumnResponsive();
            // recheck on window resize
            window.onresize = hideSearchColumnResponsive;

            $('#kt_datepicker_1,#kt_datepicker_2').datepicker({
                autoclose: true
            });
        },
        columnDefs:  [{
            targets: -1,
            width: '100px',
            title: 'Actions',
            orderable: false,
        },
            {
                targets:0,
                width: '150px',
                orderable: false
            },
            {
                targets: 1,
                width: '100px',
                render: function(data, type, full, meta) {
                    var status = {
                        1: {
                            'title': 'Pending',
                            'class': 'label-light-primary'
                        },
                        2: {
                            'title': 'Delivered',
                            'class': ' label-light-danger'
                        },
                        3: {
                            'title': 'Canceled',
                            'class': ' label-light-primary'
                        },
                        4: {
                            'title': 'Success',
                            'class': ' label-light-success'
                        },
                        5: {
                            'title': 'Info',
                            'class': ' label-light-info'
                        },
                        6: {
                            'title': 'Danger',
                            'class': ' label-light-danger'
                        },
                        7: {
                            'title': 'Warning',
                            'class': ' label-light-warning'
                        },
                    };
                    if (typeof status[data] === 'undefined') {
                        return data;
                    }
                    return '<span class="label label-lg font-weight-bold' + status[data].class + ' label-inline">' + status[data].title + '</span>';
                },
                orderable: false
            },
            {
                targets: 2,
                width: '50px',
                render: function(data, type, full, meta) {
                    var status = {
                        1: {
                            'title': 'Online',
                            'state': 'danger'
                        },
                        2: {
                            'title': 'Retail',
                            'state': 'primary'
                        },
                        3: {
                            'title': 'Direct',
                            'state': 'success'
                        },
                    };
                    if (typeof status[data] === 'undefined') {
                        return data;
                    }
                    return '<span class="label label-' + status[data].state + ' label-dot mr-2"></span>' +
                        '<span class="font-weight-bold text-' + status[data].state + '">' + status[data].title + '</span>';
                },
            },
            {
                targets: 3,
                width: '100px',
                orderable: false
            },
            {
                targets: 4,
                width: '100px',
                orderable: false,
            },
            {
                targets: 5,
                width: '200px',
                orderable: false
            },
            {
                targets: 6,
                width: '200px',
                orderable: false
            }
        ]
    });

    return table;
}








export default ContactDatatable;